/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

import { FORM_FIELD } from './constant';

const CarouselItem = ({ module, previewImg, errors }) => {
  return (
    <InfoItem.WithError
      description={pluralize(module.content[FORM_FIELD.ATHLETES.name].length, 'slide')}
      image={previewImg}
      error={errors}
      size="large"
    >
      Hero Athletes Carousel
    </InfoItem.WithError>
  );
};

export default CarouselItem;
